import app from "js/legacy-app";

app.controller('CompleteCreationRequestCtrl', ['AuthService', '$routeParams', '$scope',
    function (AuthService, $routeParams, $scope) {

        $scope.email = $routeParams.email;

        AuthService.currentUser();

    }]);